export default __webpack_public_path__ + "static/media/eva_halftone.485088a8.png";